<script>

export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: {
      type: Object,
      required: true,
    },
    infContent: {
      type: String,
      required: '',
    },
    icon: {
      type: String,
      required: '',
    },
  },

  mounted() {
    if (this.infContent) { this.createMarker(); }
    if (!this.infContent) { this.newMarker(); }
  },

  methods: {
    async createMarker() {
      const marker = await this.newMarker();
      const infoWindow = new this.google.maps.InfoWindow();

      infoWindow.setContent(this.infContent);
      infoWindow.open(this.map, marker);
      this.google.maps.event.addListener(
        marker,
        'click', () => {
          infoWindow.setContent(this.infContent);
          infoWindow.open(this.map, marker);
        },
      );
    },
    newMarker() {
      const { Marker } = this.google.maps;
      return new Marker({
        position: this.marker.position,
        marker: this.marker,
        map: this.map,
        icon: this.icon,
      });
    },
  },

  // eslint-disable-next-line vue/require-render-return
  render() { },
};
</script>
